import { buildProps } from '@vuesax-plus/utils'

import type { ExtractPropTypes } from 'vue'
import type Navbar from './navbar.vue'

export const navbarProps = buildProps({})

export type NavbarProps = ExtractPropTypes<typeof navbarProps>
export type NavbarInstance = InstanceType<typeof Navbar>
